import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const { server_url: serverUrl } = config[env]

export const state = {
    assessmentUsers: { results: [] },
    submittingUser: false,
    loadingAssessmentUsers: false,
    deletingAssessmentUser: false
}

export const getters = {
    assessmentUsers: (state) => state.assessmentUsers,
    submittingUser: (state) => state.submittingUser,
    loadingAssessmentUsers: (state) => state.loadingAssessmentUsers,
    deletingAssessmentUser: (state) => state.deletingAssessmentUser,
}

export const mutations = {
    CACHE_ASSESSMENT_USERS(state, data) {
        state.assessmentUsers = data
    },
    LOADING_ASSESSMENT_USERS(state, loading) {
        state.loadingAssessmentUsers = loading
    },
    SUBMITTING(state, value) {
        state.submittingUser = value
    },
    DELETING(state, deleting) {
        state.deletingAssessmentUser = deleting
    },
}

export const actions = {
         async fetchAssesmentUsers({ commit }, query = '') {
           commit('LOADING_ASSESSMENT_USERS', true)
           try {
             const res = await axios.get(
               `${serverUrl}/assessment/assessment_user/${query}`
             )
             commit('CACHE_ASSESSMENT_USERS', res.data)
             commit('LOADING_ASSESSMENT_USERS', false)
             return { error: null, data: res.data }
           } catch (error) {
             commit('LOADING_ASSESSMENT_USERS', false)
             return { error, data: null }
           }
         },

         async createUpdateAssesmentUser({ commit }, { method, payload }) {
           const url =
             method === 'put'
               ? `${payload.url}custom_update/`
               : `${serverUrl}/assessment/assessment_user/custom_post/`

           commit('SUBMITTING', true)
           try {
             const res = await axios[method](url, payload)
             commit('SUBMITTING', false)
             return { success: true, response: res.data }
           } catch (error) {
             commit('SUBMITTING', false)
             return { success: false, error }
           }
         },

         async deleteAssessmentUser({ commit }, url) {
           commit('DELETING', true)
           try {
             const res = await axios.delete(url)
             commit('DELETING', false)
             return { success: true, status: res.status }
           } catch (error) {
             commit('DELETING', false)
             return { success: false, error }
           }
         },

         async massiveUserCreation({ commit }, payload) {
           try {
             const { data } = await axios.post(
               `${serverUrl}/assessment/assessment_user/massive_user_creation/`,
               payload
             )
             return { error: null, data }
           } catch (error) {
             return { error, data: null }
           }
         },

         async AssessmentUserThirdparties({ commit }) {
           try {
             const res = await axios.get(
               `${serverUrl}/assessment/assessment_user/thirdparties/`
             )
             return { error: null, data: res.data }
           } catch (error) {
             return { error: error, data: null }
           }
         },
       }